import { Button, Container, Grid, TextField } from '@mui/material';
import { useState } from 'react';

import { useModalContext } from '@/modals/VNModalProvider';

import VnModalBody from '../VnModalBody';
import VnModalFooter from '../VnModalFooter';

const DeleteFeedItemModal = ({ onDelete }) => {
  const [itemId, setItemId] = useState('');
  const { onClose } = useModalContext();
  return (
    <div>
      <VnModalBody>
        <Container className="no-padding" section="component" maxWidth="lg">
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="Feed Item Id (or separate with commas)"
              fullWidth
              size="small"
              onChange={(e) => setItemId(e.target.value)}
            />
          </Grid>
        </Container>
      </VnModalBody>
      <VnModalFooter
        right={
          <>
            {' '}
            <Button color="primary" variant="contained" autoFocus disabled={itemId.length === 0} onClick={() => onDelete(itemId)}>
              Delete
            </Button>
            <Button autoFocus variant="contained" className="cancel-button" onClick={onClose}>
              Cancel
            </Button>
          </>
        }
      />
    </div>
  );
};

export default DeleteFeedItemModal;
